import { strIsNullOrEmpty } from '@fox/atoms/utils/string';
import { IBlockDefinition, IBlockProps } from '@fox/blocks/contracts/block';
import { URL_REDIRECT_BLOCK_TYPE } from '../../../form-block-types';

export function URLRedirectBLock({ props }: IBlockProps<{ url: string; target: string }>) {
	if (!strIsNullOrEmpty(props.url)) {
		window.open(props.url, props.target ?? '_self');
	}
	return <></>;
}
export const URLRedirectBlockRuntime: IBlockDefinition<{ url: string; target: string }> = {
	type: URL_REDIRECT_BLOCK_TYPE,
	Component: URLRedirectBLock
};
